// extracted by mini-css-extract-plugin
export var aside = "PageLayout-module--aside--e0d46";
export var consultationCtaMini = "PageLayout-module--consultationCtaMini--9ba36";
export var consultationCtaMiniMain = "PageLayout-module--consultationCtaMiniMain--fd033";
export var errorPage = "PageLayout-module--errorPage--0ff31";
export var fixed = "PageLayout-module--fixed--e121a";
export var layout = "PageLayout-module--layout--ef1ec";
export var main = "PageLayout-module--main--4dae8";
export var root = "PageLayout-module--root--3f2c9";